module.exports = __webpack_public_path__ + "img/person-1.15053e41.png";